export default "__VITE_ASSET__XTtCxD5h__"